import { api } from '../client';
import type { Notification, NotificationType } from '../types';

interface ListParams {
  all?: boolean;
  userId?: number;
}

export const notificationsApi = {
  list: (params?: ListParams) =>
    api.get<Notification[]>('/notifications', { query: params }),
  types: () => api.get<NotificationType[]>('/notifications/types'),
  create: (n: Partial<Notification>) =>
    api.post<Notification>('/notifications', { body: n }),
  update: (id: number, n: Notification) =>
    api.put<Notification>(`/notifications/${id}`, { body: n }),
  delete: (id: number) => api.delete<void>(`/notifications/${id}`),
  test: () => api.post<unknown>('/notifications/test'),
};
